export const CANVAS_SIZE_ID = "builder-ui-canvas-size";

export const MOBILE_WIDTH = 390;
export const TABLET_WIDTH = 768;
export const DESKTOP_WIDTH = 1440;
